import { useState, useEffect } from "react";
import classNames from "classnames";
import Image from "../Image";

const Dropdown = ({
  id,
  hoverEvent = true,
  type = "text",
  imgSrc,
  imgAlt,
  title = "title or img needed",
  align = "left",
  btnClassName = "",
  children,
}) => {
  const [dropdownHover, setDropdownHover] = useState(false);
  const [dropdownClicked, setDropdownClicked] = useState(false);

  function setDropdownWindowPosition() {
    const dropdown = document.querySelector(`#${id}`);
    if (!dropdown) return;

    const dropdownRect = dropdown.getBoundingClientRect();
    const childrenContainer = document.querySelector(`#children-container-${id}`);
    const childrenContainerRect = childrenContainer.getBoundingClientRect();

    if (dropdownRect.bottom + childrenContainerRect.height + 16 > window.innerHeight) {
      childrenContainer.style.top = `-${childrenContainerRect.height}px`;
    } else {
      childrenContainer.style.top = "100%";
    }
  }

  function onHoverEvent(bool) {
    if (hoverEvent) {
      setDropdownWindowPosition();
      setDropdownHover(bool);
    }
  }

  useEffect(() => {
    function handleClick(e) {
      const clickedElement = e.target.parentElement;
      const dropdown = document.querySelector(`#${id}`);
      if (!dropdown) return;

      setDropdownWindowPosition();

      if (dropdown !== clickedElement && dropdown !== e.target) {
        setDropdownClicked(false);
      }

      if (dropdown.lastChild !== e.target && dropdown.lastChild.contains(e.target)) {
        setDropdownClicked(false);
        setDropdownHover(false);
      }
    }

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  });

  return (
    <div
      id={id}
      onMouseEnter={() => onHoverEvent(true)}
      onMouseLeave={() => onHoverEvent(false)}
      className="position-relative"
    >
      {type === "img" ? (
        <Image
          src={imgSrc}
          alt={imgAlt}
          className="dropdown-img"
          style={{ zIndex: 1000 }}
          onClick={() => setDropdownClicked(!dropdownClicked)}
        />
      ) : (
        <button
          type="button"
          title={title}
          onClick={() => setDropdownClicked(!dropdownClicked)}
          className={classNames("btn-transparent navlink big mb-0", btnClassName)}
          style={{ zIndex: 1000 }}
        >
          {title}
        </button>
      )}
      <div
        id={`children-container-${id}`}
        style={{
          visibility: dropdownHover || dropdownClicked ? "inherit" : "hidden",
          zIndex: 1010,
        }}
        className={classNames(
          "d-flex bg-white flex-column py-2 dropdown-menu",
          align === "right" ? "dd-menu-right" : "dd-menu-left",
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default Dropdown;
